module.exports = __webpack_public_path__ + "img/Best of Tessin Rot.14d3ee1a.jpg";